<script setup lang="ts">
import i18n from '@/i18n';

defineProps({
   title: {
      type: String,
      default: () => i18n.global.t('global.caution'),
   },
   cancelText: {
      type: String,
      default: () => i18n.global.t('actions.cancel', 2),
   },
   confirmText: {
      type: String,
      default: () => i18n.global.t('actions.delete', 2),
   },
   loading: {
      type: Boolean,
      default: false,
   },
   canSave: {
      type: Boolean,
      default: true,
   },
});

const emits = defineEmits(['close', 'confirm']);
</script>

<template>
   <NxtModal
      :cancel-text="cancelText"
      :primary-action-text="confirmText"
      :title="title"
      :primary-button-type="'danger'"
      :loading="loading"
      :primary-action-disabled="!canSave"
      @on-cancel="emits('close')"
      @on-primary-action="emits('confirm')"
   >
      <div class="modal__main">
         <i class="fas fa-exclamation-triangle" />
         <div class="modal__main__message">
            <slot />
         </div>

         <slot name="dropdown" />
      </div>
   </NxtModal>
</template>

<style lang="scss" scoped>
.modal__main {
   margin: toRem(48) 0;
}
.modal__main .fa-exclamation-triangle {
   font-size: 3rem;
   width: 100%;
   text-align: center;
   margin-bottom: var(--nxt-gutter);
   color: var(--text-error);
}
.modal__main__message {
   text-align: center;
}
</style>
